type UnitNames =
    | 'meters'
    | 'minutes'
    | 'minute'
    | 'degrees'
    | 'metersPerSecond'
    | 'knots'

export const Units: Record<UnitNames, string> = {
    meters: 'm',
    minutes: 'minutes',
    minute: 'minute',
    degrees: '°',
    metersPerSecond: 'm/s',
    knots: 'Kt',
}

export type CurrentView = 'headUp' | 'northUp'

export type Status = 'loading' | 'error' | 'success' | ''

export enum RiskZonesEnum {
    heavyRolling = 'Heavy Rolling Zone',
    parametricRoll = 'Parametric Roll Zone',
    transverseAcceleration = 'High Acceleration Force Zone',
}

export type ZoneVisibilityKey =
    | 'heavyRollingZone'
    | 'parametricRollZone'
    | 'transverseAccelerationZone'
    | 'safeZone'
    | 'constraintZone'

export type ZoneVisibility = Record<ZoneVisibilityKey, boolean>

export const defaultZoneVisibility: ZoneVisibility = {
    heavyRollingZone: true,
    parametricRollZone: true,
    transverseAccelerationZone: true,
    safeZone: true,
    constraintZone: true,
}

export const chartColors = {
    heavyRollingZone: '#9980E0',
    heavyRollingZone_light: '#8454D6',
    parametricRollZone: '#F4ACED',
    parametricRollZone_light: '#FE92E9',
    transverseAccelerationZone: 'rgba(175, 86, 3, 0.45)',
    transverseAccelerationZone_light: '#AF5603',
    safeZone: '#DEE8F6',
    constraintZone: '#B6DBD5',
    black: '#00243D',
    grey: '#C7C7CC',
    greyDark: '#8E8E93',
    waveDirection: '#8638E5',
    windDirection: '#1DC6BC',
    swellDirection: '#FFAC1C',
}
